import useApi, { ApiOptions } from '../base/useApi';
import OrganisationDTO from '@src/adapters/dto/organisation/OrganisationDTO';

interface Params {
  id?: string;
  name: string;
  codeSet: string;
  logoImageType?: string;
}

type Result = OrganisationDTO;

const options: ApiOptions = {
  method: 'put',
  urlPath: '/organisation/edit',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useUpdateOrganisationLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useUpdateOrganisationLazy;
